module.exports = __webpack_public_path__ + "static/sea-of-poppies-b561d6b85b10a1ea351e26e38350dc96.jpg";